// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RoV7","delete":"styles_delete__ajJqe","update":"styles_update__Fpp9k","add":"styles_add__3GW0q"};